import { render, staticRenderFns } from "./BookingsReports.vue?vue&type=template&id=f5952ac2"
import script from "./BookingsReports.vue?vue&type=script&lang=js"
export * from "./BookingsReports.vue?vue&type=script&lang=js"
import style0 from "./BookingsReports.vue?vue&type=style&index=0&id=f5952ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports